<template>
    <div class="partyworkdetails">
        <div class="box_bg_1 flex-col">
            <span class="text_1">强化党建引领</span>
            <span class="text_2">奋力推进企业高质量发展</span>
          </div>
          <div class="box_5 flex-col">
            <div class="box_6 flex-row">
              <div class="text-wrapper_1 flex-col justify-between">
                <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;党务建设</span>
                <span class="text_14">{{modelitemName}}</span>
              </div>
              <div class="box_7 flex-row justify-between">
                <div class="text-wrapper_2 flex-col" @click="setState('PT01')"   :style="{'background-color':form.modelitem=='PT01'?'rgba(176, 23, 1, 1)':'white'}">
                    <span class="text_15" :style="{'color':form.modelitem=='PT01'?'white':'rgba(176, 23, 1, 1)'}">党建工作</span>
                  </div>
                  <div class="text-wrapper_3 flex-col" @click="setState('PT02')"  :style="{'background-color':form.modelitem=='PT02'?'rgba(176, 23, 1, 1)':'white'}">
                    <span class="text_16"  :style="{'color':form.modelitem=='PT02'?'white':'rgba(176, 23, 1, 1)'}">党建文化</span>
                  </div>
                  <div class="text-wrapper_4 flex-col" @click="setState('PT03')" :style="{'background-color':form.modelitem=='PT03'?'rgba(176, 23, 1, 1)':'white'}">
                    <span class="text_17"  :style="{'color':form.modelitem=='PT03'?'white':'rgba(176, 23, 1, 1)'}">社会责任</span>
                  </div>
                  <div class="text-wrapper_5 flex-col" @click="setState('PT04')" :style="{'background-color':form.modelitem=='PT04'?'rgba(176, 23, 1, 1)':'white'}">
                    <span class="text_18" :style="{'color':form.modelitem=='PT04'?'white':'rgba(176, 23, 1, 1)'}">党建活动</span>
                  </div>
              </div>
              <div class="text-wrapper_6 flex-col">
                <span class="text_19">4001-300-137</span>
              </div>
              <div class="box_8 flex-row">
                <div class="image-text_1 flex-col justify-between" style="cursor:pointer">
                  <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    src="@/assets/client/tel.png"
                  />
                  <span class="text-group_1">业务咨询</span>
                </div>
              </div>
            </div>
            <div class="image-wrapper_1 flex-row">
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="@/assets/client/dx_2.png"
              />
            </div>
            <div style="text-align: center;margin-top: 1.77vw;">
              <span class="text_20"
              >{{detailInfo.news_title}}</span>
            </div>
          <div class="box_8_2 flex-row justify-between">
            <div class="text-wrapper_7">
              <span class="text_21">分类：</span>
              <span class="text_22">{{detailInfo.newsmodelType}}</span>
              <span class="text_23">编辑：</span>
                <span class="text_22">{{detailInfo.news_author}}</span>
                 <span class="text_24">来源：</span>
                 <span class="text_22">{{detailInfo.news_source}}</span>
                <span class="text_25">发布时间：</span>
                <span class="text_22">{{detailInfo.publishdate}}</span>
            </div>
          </div>
          <img
        class="image_3"
        referrerpolicy="no-referrer"
        src="@/assets/client/underline.png"
      />
      <div
      class="html-div"
      style="width:72.97vw;height:auto;margin: 1.66vw 0 0 13.54vw;padding:20px;box-sizing:border-box;"
      v-html="detailInfo.news_content"
      ></div>
      <div  style="height:100px;margin-left:13.54vw ;">
        <div v-if="filesFlag" style="font-size: 1vw">附件：</div>
            <AttachmentList
            @AttachmentList="AttachmentList"
            ref="fileList1"
            :objectID="uploadForm.objectID"
            :UseType="uploadForm.UseType"
            :TableName="uploadForm.TableName"
            :ShowDelete="false"
            >
            </AttachmentList>
        </div>
      <div class="box_9 flex-col"></div>
      <div class="box_10 flex-row justify-between">
        <div class="text-wrapper_11">
          <div v-if="detailInfo.previous_id!=''">
            <span class="text_33">上一篇：</span>
            <span class="text_34" @click="toNews('previous')"
              >{{detailInfo.previous_title}}</span
            >
          </div>
        </div>
        <div class="text-wrapper_12">
          <div  v-if="detailInfo.next_id!=''">
            <span class="text_36">下一篇:</span>
            <span class="text_35"  @click="toNews('next')">{{detailInfo.next_title}}&nbsp;</span>
          </div>
        </div>
      </div>
          </div>

    </div>
</template>
<script>
    import AttachmentList from "@/components/AttachmentList";
      export default{
        components: {AttachmentList },
          data(){
              return{
                  detailInfo:{},
                  form:{
                      id:"",
                      modelitem:"PT01",
                      newsmodel:"PartyType"
                  },
                  uploadForm: {
                    objectID: "",
                    UseType: 0,
                    TableName: "t_news_main",
                  },
                  modelitemName:"党建工作",
                  filesFlag:false,
                  detailInfo: {},
                  loading:false,
              }
          },
          methods:{
              setState(state){
                  let that = this;
                  that.form.modelitem = state;
                    that.$router.push({
                    path: "/Client/PartyWorkMore",
                    query: {
                        modelitem:state
                    },
                });
              },
              selectNews()
              {
                let that = this;
                  that.$api.post("/Client/getNewsDetails", that.form,
                      function (res) {
                          if (res.code === "200") {
                              that.detailInfo=res.data;
                              that.uploadForm.objectID = res.data.id;
                              that.$nextTick(() => {
                                that.$refs.fileList1.GetAttachmentList();
                              });
                              that.loading = false;

                          }
                      },
                      function (res) {
                          that.$message.error("服务异常，信息出错");
                      }
                  );
              },
              toNews(type)
              {
                let that = this;
                if(type=='previous'){
                if(that.detailInfo.previous_is_open_attachment=="1"){
                  window.open(process.env.VUE_APP_FileAddress.replace('fileapi/', '')+that.detailInfo.previous_FilePath, '_blank');
                } else if (that.detailInfo.previous_is_open_url=="1"){
                  window.open(that.detailInfo.previous_url, '_blank');
                }else{
                  that.form.id = that.detailInfo.previous_id;
                  that.selectNews();
                }

              }else{
                if(that.detailInfo.next_is_open_attachment=="1"){
                  window.open(process.env.VUE_APP_FileAddress.replace('fileapi/', '')+that.detailInfo.next_FilePath, '_blank');
                } else if (that.detailInfo.next_is_open_url=="1"){
                  window.open(that.detailInfo.next_url, '_blank');
                }else{
                  that.form.id = that.detailInfo.next_id;
                  that.selectNews();
                }
              }
              },
              AttachmentList(files,objid){
                  if(files !=null && files.length>0){
                      this.filesFlag=true;
                  }
              },
          },
          mounted(){
              let that = this;
              that.loading = true;
              that.form.id=this.$route.query.id;
              that.form.modelitem = this.$route.query.modelitem;
              that.form.newsmodel = this.$route.query.newsmodel;
              if(this.$route.query.modelitem=='PT01'){
                that.modelitemName ="党建工作";
              }
              if(this.$route.query.modelitem=='PT02'){
                that.modelitemName ='党建文化';
              }
              if(this.$route.query.modelitem=='PT03'){
                that.modelitemName ='社会责任';
              }
              if(this.$route.query.modelitem=='PT04'){
                that.modelitemName ='党建活动';
              }
                that.selectNews();
          },
      }
  </script>
  <style scoped>
    @import '../../../assets/client/partyworkdetails.css';
</style>
